var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "jobs_wrapper", attrs: { id: "top_page" } }, [
    _c("div", { class: { overlay_setting: _vm.isLoadingData } }, [
      _c("i", { class: { loadding_setting: _vm.isLoadingData } })
    ]),
    !_vm.isLoadingData
      ? _c("div", [
          _vm.entryPageName
            ? _c(
                "h1",
                {
                  staticClass: "jobs_page_title_preview break-word",
                  style: { color: _vm.colorSetting.pageText }
                },
                [_vm._v("\n      " + _vm._s(_vm.entryPageName) + "\n    ")]
              )
            : _c(
                "h1",
                {
                  staticClass: "jobs_page_title",
                  style: { color: _vm.colorSetting.pageText }
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.labelProperties.ENTRY_PAGE_TITLE) +
                      "\n    "
                  )
                ]
              ),
          _vm.entryPageOverview
            ? _c(
                "p",
                { staticClass: "jobs_table_annotation_preview break-word" },
                [_vm._v(_vm._s(_vm.entryPageOverview))]
              )
            : _vm._e(),
          _c("div", { staticClass: "entry_stepbar" }, [
            _c(
              "ul",
              {
                staticClass: "entry_stepbar_list",
                style: { border: "1px solid" + _vm.colorSetting.borderColor }
              },
              [
                _c(
                  "li",
                  {
                    staticClass: "entry_stepbar_item",
                    style: [
                      _vm.step >= 1
                        ? {
                            backgroundColor: _vm.colorSetting.keyColor,
                            "--keyColor": _vm.colorSetting.keyColor
                          }
                        : {}
                    ]
                  },
                  [
                    _vm.message && _vm.message.titleEntry
                      ? _c(
                          "span",
                          {
                            staticClass: "entry_stepbar_label",
                            style: [
                              _vm.step >= 1
                                ? { color: _vm.colorSetting.highlightText }
                                : {}
                            ]
                          },
                          [
                            _c("span", { staticClass: "title-default" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.message.titleEntry) +
                                  "\n            "
                              )
                            ]),
                            _c("span", { staticClass: "title-mobile" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.labelProperties.ENTRY_STEP_MOBILE_TITLE
                                  ) +
                                  "\n            "
                              )
                            ])
                          ]
                        )
                      : _c(
                          "span",
                          {
                            staticClass: "entry_stepbar_label",
                            style: [
                              _vm.step >= 1
                                ? { color: _vm.colorSetting.highlightText }
                                : {}
                            ]
                          },
                          [
                            _c("span", { staticClass: "title-default" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.labelProperties.ENTRY_STEP_TITLE) +
                                  "\n            "
                              )
                            ]),
                            _c("span", { staticClass: "title-mobile" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.labelProperties.ENTRY_STEP_MOBILE_TITLE
                                  ) +
                                  "\n            "
                              )
                            ])
                          ]
                        )
                  ]
                ),
                _c(
                  "li",
                  {
                    staticClass: "entry_stepbar_item",
                    style: [
                      _vm.step >= 2
                        ? {
                            backgroundColor: _vm.colorSetting.keyColor,
                            "--keyColor": _vm.colorSetting.keyColor
                          }
                        : {
                            backgroundColor: _vm.colorSetting.subColor,
                            "--keyColor": _vm.colorSetting.subColor
                          }
                    ]
                  },
                  [
                    _vm.message && _vm.message.titleConfirm
                      ? _c(
                          "span",
                          {
                            staticClass: "entry_stepbar_label",
                            style: [
                              _vm.step >= 2
                                ? { color: _vm.colorSetting.highlightText }
                                : { color: _vm.colorSetting.pageText }
                            ]
                          },
                          [
                            _c("span", { staticClass: "title-default" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.message.titleConfirm) +
                                  "\n            "
                              )
                            ]),
                            _c("span", { staticClass: "title-mobile" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.labelProperties
                                      .CONFIRM_STEP_MOBILE_TITLE
                                  ) +
                                  "\n            "
                              )
                            ])
                          ]
                        )
                      : _c(
                          "span",
                          {
                            staticClass: "entry_stepbar_label",
                            style: [
                              _vm.step >= 2
                                ? { color: _vm.colorSetting.highlightText }
                                : { color: _vm.colorSetting.pageText }
                            ]
                          },
                          [
                            _c("span", { staticClass: "title-default" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.labelProperties.CONFIRM_STEP_TITLE
                                  ) +
                                  "\n            "
                              )
                            ]),
                            _c("span", { staticClass: "title-mobile" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.labelProperties
                                      .CONFIRM_STEP_MOBILE_TITLE
                                  ) +
                                  "\n            "
                              )
                            ])
                          ]
                        )
                  ]
                ),
                _c(
                  "li",
                  {
                    staticClass: "entry_stepbar_item",
                    style: [
                      _vm.step >= 3
                        ? {
                            backgroundColor: _vm.colorSetting.keyColor,
                            "--keyColor": _vm.colorSetting.keyColor
                          }
                        : { backgroundColor: _vm.colorSetting.subColor }
                    ]
                  },
                  [
                    _vm.message && _vm.message.titleCompletion
                      ? _c(
                          "span",
                          {
                            staticClass: "entry_stepbar_label",
                            style: [
                              _vm.step >= 3
                                ? { color: _vm.colorSetting.highlightText }
                                : { color: _vm.colorSetting.pageText }
                            ]
                          },
                          [
                            _c("span", { staticClass: "title-default" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.message.titleCompletion) +
                                  "\n            "
                              )
                            ]),
                            _c("span", { staticClass: "title-mobile" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.labelProperties
                                      .COMPLETE_STEP_MOBILE_TITLE
                                  ) +
                                  "\n            "
                              )
                            ])
                          ]
                        )
                      : _c(
                          "span",
                          {
                            staticClass: "entry_stepbar_label",
                            style: [
                              _vm.step >= 3
                                ? { color: _vm.colorSetting.highlightText }
                                : { color: _vm.colorSetting.pageText }
                            ]
                          },
                          [
                            _c("span", { staticClass: "title-default" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.labelProperties.COMPLETE_STEP_TITLE
                                  ) +
                                  "\n            "
                              )
                            ]),
                            _c("span", { staticClass: "title-mobile" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.labelProperties
                                      .COMPLETE_STEP_MOBILE_TITLE
                                  ) +
                                  "\n            "
                              )
                            ])
                          ]
                        )
                  ]
                )
              ]
            )
          ]),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.step === 1,
                  expression: "step === 1"
                }
              ]
            },
            [
              _c("div", { attrs: { id: "warning_enter_value" } }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.messages && _vm.messages.length > 0,
                        expression: "messages && messages.length > 0"
                      }
                    ],
                    staticClass: "entry_error"
                  },
                  [
                    _c("p", { staticClass: "entry_error_title" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.messageProperties.ENTRY_ERROR_TITLE) +
                          "\n          "
                      )
                    ]),
                    _c(
                      "ul",
                      { staticClass: "entry_error_list" },
                      _vm._l(_vm.messages, function(message, index) {
                        return _c(
                          "li",
                          { key: index, staticClass: "entry_error_item" },
                          [
                            _c("a", { staticClass: "entry_error_link" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(message) +
                                  "\n              "
                              )
                            ])
                          ]
                        )
                      }),
                      0
                    )
                  ]
                )
              ]),
              _vm.categories.length > 0
                ? _c(
                    "div",
                    _vm._l(_vm.categories, function(category, index) {
                      return _c("div", { key: index }, [
                        category &&
                        !category.categoryDeleted &&
                        !_vm.isEmptyCategory(index)
                          ? _c("div", { staticClass: "mt-2" }, [
                              _c(
                                "h2",
                                {
                                  staticClass: "jobs_category_title",
                                  style: {
                                    color: _vm.colorSetting.pageText,
                                    borderLeftColor: _vm.colorSetting.keyColor
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(category.categoryName) +
                                      "\n              "
                                  ),
                                  category.countCate
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(category.countCate) +
                                            "\n              "
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "jobs_table_wrapper" },
                                _vm._l(category.item, function(
                                  item,
                                  indexItem
                                ) {
                                  return _c(
                                    "table",
                                    {
                                      key: indexItem,
                                      staticClass: "jobs_table"
                                    },
                                    [
                                      _c(
                                        "tbody",
                                        { staticClass: "jobs_table_body" },
                                        [
                                          !_vm.isEmptyItem(item)
                                            ? _c(
                                                "tr",
                                                {
                                                  staticClass: "jobs_table_rows"
                                                },
                                                [
                                                  _c(
                                                    "th",
                                                    {
                                                      staticClass:
                                                        "jobs_table_head",
                                                      style: [
                                                        {
                                                          backgroundColor:
                                                            _vm.colorSetting
                                                              .subColor
                                                        },
                                                        indexItem === 0
                                                          ? {
                                                              border:
                                                                "1px solid" +
                                                                _vm.colorSetting
                                                                  .borderColor
                                                            }
                                                          : {
                                                              borderLeft:
                                                                "1px solid" +
                                                                _vm.colorSetting
                                                                  .borderColor,
                                                              borderRight:
                                                                "1px solid" +
                                                                _vm.colorSetting
                                                                  .borderColor,
                                                              borderBottom:
                                                                "1px solid" +
                                                                _vm.colorSetting
                                                                  .borderColor
                                                            }
                                                      ]
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "jobs_table_head_holder"
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "jobs_table_label",
                                                              style: {
                                                                color:
                                                                  _vm
                                                                    .colorSetting
                                                                    .pageText
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          " +
                                                                  _vm._s(
                                                                    item.itemName
                                                                  ) +
                                                                  "\n                        "
                                                              )
                                                            ]
                                                          ),
                                                          item.itemRequired
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "entry_required_label",
                                                                  style: {
                                                                    backgroundColor:
                                                                      _vm
                                                                        .colorSetting
                                                                        .requiredLabel,
                                                                    color:
                                                                      _vm
                                                                        .colorSetting
                                                                        .requiredLabelText
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                        " +
                                                                      _vm._s(
                                                                        _vm
                                                                          .labelProperties
                                                                          .LABEL_REQUIRE
                                                                      ) +
                                                                      "\n                      "
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e()
                                                        ]
                                                      ),
                                                      item.resourceField
                                                        .length === 1 &&
                                                      (item.resourceField[0]
                                                        .min_length ||
                                                        item.resourceField[0]
                                                          .max_length)
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "setting_range_allow_input"
                                                            },
                                                            [
                                                              item
                                                                .resourceField[0]
                                                                .type ===
                                                                "textarea" ||
                                                              item
                                                                .resourceField[0]
                                                                .type ===
                                                                "text" ||
                                                              item.resourceField[0].type.includes(
                                                                "email"
                                                              ) ||
                                                              item
                                                                .resourceField[0]
                                                                .type ===
                                                                "tel" ||
                                                              item
                                                                .resourceField[0]
                                                                .type === "url"
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm
                                                                          .labelProperties
                                                                          .WORD_COUNT
                                                                      ) +
                                                                        " " +
                                                                        _vm._s(
                                                                          item
                                                                            .resourceField[0]
                                                                            .min_length
                                                                        ) +
                                                                        " ~ " +
                                                                        _vm._s(
                                                                          item
                                                                            .resourceField[0]
                                                                            .max_length
                                                                        )
                                                                    )
                                                                  ])
                                                                : _vm._e(),
                                                              item
                                                                .resourceField[0]
                                                                .type ===
                                                                "integer" ||
                                                              item
                                                                .resourceField[0]
                                                                .type ===
                                                                "calc" ||
                                                              item
                                                                .resourceField[0]
                                                                .type ===
                                                                "number"
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm
                                                                          .labelProperties
                                                                          .RANGE
                                                                      ) +
                                                                        " " +
                                                                        _vm._s(
                                                                          item
                                                                            .resourceField[0]
                                                                            .min_length
                                                                        ) +
                                                                        " ~ " +
                                                                        _vm._s(
                                                                          item
                                                                            .resourceField[0]
                                                                            .max_length
                                                                        )
                                                                    )
                                                                  ])
                                                                : _vm._e()
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  ),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "jobs_table_cell",
                                                      style: [
                                                        indexItem === 0
                                                          ? {
                                                              border:
                                                                "1px solid" +
                                                                _vm.colorSetting
                                                                  .borderColor
                                                            }
                                                          : {
                                                              borderLeft:
                                                                "1px solid" +
                                                                _vm.colorSetting
                                                                  .borderColor,
                                                              borderRight:
                                                                "1px solid" +
                                                                _vm.colorSetting
                                                                  .borderColor,
                                                              borderBottom:
                                                                "1px solid" +
                                                                _vm.colorSetting
                                                                  .borderColor
                                                            }
                                                      ]
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "jobs_table_form_rows"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "jobs_table_form_item"
                                                            },
                                                            [
                                                              _vm._l(
                                                                _vm.buildListItem(
                                                                  item.resourceField
                                                                ),
                                                                function(
                                                                  resourceField,
                                                                  indexResourceField
                                                                ) {
                                                                  return _c(
                                                                    "div",
                                                                    {
                                                                      key: indexResourceField,
                                                                      staticClass:
                                                                        "row"
                                                                    },
                                                                    _vm._l(
                                                                      resourceField.filter(
                                                                        function(
                                                                          resourceSetting
                                                                        ) {
                                                                          return (
                                                                            resourceSetting &&
                                                                            !resourceSetting.isDeletedByMainSystem
                                                                          )
                                                                        }
                                                                      ),
                                                                      function(
                                                                        resource,
                                                                        indexResource
                                                                      ) {
                                                                        return _c(
                                                                          "div",
                                                                          {
                                                                            key: indexResource,
                                                                            staticClass:
                                                                              "col"
                                                                          },
                                                                          [
                                                                            resource.type !==
                                                                            "blank"
                                                                              ? _c(
                                                                                  "div",
                                                                                  [
                                                                                    _c(
                                                                                      "InputComponent",
                                                                                      {
                                                                                        staticClass:
                                                                                          "mt-1",
                                                                                        attrs: {
                                                                                          resource: resource,
                                                                                          master: _vm.getMasterData(
                                                                                            resource.master_name
                                                                                          ),
                                                                                          year:
                                                                                            _vm.year,
                                                                                          month:
                                                                                            _vm.month,
                                                                                          day:
                                                                                            _vm.day,
                                                                                          draftColors:
                                                                                            _vm.colorSetting,
                                                                                          photo:
                                                                                            _vm.photo,
                                                                                          itemJob: false,
                                                                                          numberOfItem:
                                                                                            item
                                                                                              .resourceField
                                                                                              .length,
                                                                                          itemName:
                                                                                            item.itemName
                                                                                        },
                                                                                        on: {
                                                                                          updatePhoto:
                                                                                            _vm.updatePhoto,
                                                                                          updateFiles:
                                                                                            _vm.updateFiles,
                                                                                          updateCheckErrorInput:
                                                                                            _vm.updateCheckErrorInput
                                                                                        }
                                                                                      }
                                                                                    )
                                                                                  ],
                                                                                  1
                                                                                )
                                                                              : _vm._e()
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                                    0
                                                                  )
                                                                }
                                                              ),
                                                              item.viewAnnotation &&
                                                              item.annotationText
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "jobs_table_annotation break-word",
                                                                      style: {
                                                                        color:
                                                                          _vm
                                                                            .colorSetting
                                                                            .pageText
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                          ※" +
                                                                          _vm._s(
                                                                            item.annotationText
                                                                          ) +
                                                                          "\n                        "
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ],
                                                            2
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    ]
                                  )
                                }),
                                0
                              ),
                              index === _vm.findLastCategoryIndex("careers")
                                ? _c(
                                    "div",
                                    { staticClass: "setting_unit_add" },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "setting_unit_add_btn",
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.duplicateCategory(
                                                index
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.labelProperties
                                                  .DUPLICATE_CARRIER
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              index === _vm.findLastCategoryIndex("educations")
                                ? _c(
                                    "div",
                                    { staticClass: "setting_unit_add" },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "setting_unit_add_btn",
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.duplicateCategory(
                                                index
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.labelProperties
                                                  .DUPLICATE_EDUCATION
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          : _vm._e()
                      ])
                    }),
                    0
                  )
                : _vm._e(),
              _vm.policy.isEnabledPolicy && _vm.policy.content !== ""
                ? _c("div", { staticClass: "mt-2" }, [
                    _c(
                      "h2",
                      {
                        staticClass: "jobs_category_title",
                        style: {
                          color: _vm.colorSetting.pageText,
                          borderLeftColor: _vm.colorSetting.keyColor
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.labelProperties.PRIVACY_POLICY_CATEGORY
                            ) +
                            "\n        "
                        )
                      ]
                    ),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.policy.content,
                          expression: "policy.content"
                        }
                      ],
                      staticClass: "jobs_form_textarea",
                      attrs: { readonly: "" },
                      domProps: { value: _vm.policy.content },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.policy, "content", $event.target.value)
                        }
                      }
                    }),
                    _c("div", { staticClass: "entry_policy_checkbox" }, [
                      _c("label", { staticClass: "jobs_form_label" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.agreePrivacyPolicy,
                              expression: "agreePrivacyPolicy"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(_vm.agreePrivacyPolicy)
                              ? _vm._i(_vm.agreePrivacyPolicy, null) > -1
                              : _vm.agreePrivacyPolicy
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.agreePrivacyPolicy,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.agreePrivacyPolicy = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.agreePrivacyPolicy = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.agreePrivacyPolicy = $$c
                              }
                            }
                          }
                        }),
                        _c(
                          "span",
                          {
                            staticClass: "entry_policy_checkbox_text",
                            style: { color: _vm.colorSetting.pageText }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.labelProperties.PRIVACY_POLICY_DEFAULT
                                ) +
                                "\n            "
                            )
                          ]
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm.policy.isEnabledUrl && _vm.policy.textLink !== ""
                ? _c("div", { staticClass: "entry_policy_checkbox" }, [
                    _c("label", { staticClass: "jobs_form_label" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.agreePrivacyPolicyLink,
                            expression: "agreePrivacyPolicyLink"
                          }
                        ],
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.agreePrivacyPolicyLink)
                            ? _vm._i(_vm.agreePrivacyPolicyLink, null) > -1
                            : _vm.agreePrivacyPolicyLink
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.agreePrivacyPolicyLink,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.agreePrivacyPolicyLink = $$a.concat([
                                    $$v
                                  ]))
                              } else {
                                $$i > -1 &&
                                  (_vm.agreePrivacyPolicyLink = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.agreePrivacyPolicyLink = $$c
                            }
                          }
                        }
                      }),
                      _c(
                        "a",
                        {
                          staticClass: "ml-1 mr-3",
                          style: { color: _vm.colorSetting.linkText },
                          attrs: { href: _vm.policy.url, target: "_blank" }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.policy.textLink) +
                              "\n          "
                          )
                        ]
                      )
                    ])
                  ])
                : _vm._e(),
              _c("div", { staticClass: "jobs_btn_box" }, [
                _c(
                  "button",
                  {
                    staticClass: "jobs_btn_primary",
                    class:
                      _vm.isAgreePrivacy() && _vm.countInputError === 0
                        ? ""
                        : "jobs_btn_disabled",
                    style: {
                      color: _vm.colorSetting.mainButtonText,
                      backgroundColor: _vm.colorSetting.mainButton,
                      border: "1px solid" + _vm.colorSetting.borderColor
                    },
                    on: {
                      click: function($event) {
                        return _vm.nextStep(2)
                      }
                    }
                  },
                  [
                    !_vm.button.confirmButton
                      ? _c("span", [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.labelProperties.CONFIRM_BUTTON) +
                              "\n          "
                          )
                        ])
                      : _c("span", [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.button.confirmButton) +
                              "\n          "
                          )
                        ])
                  ]
                )
              ])
            ]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.step === 2,
                  expression: "step === 2"
                }
              ]
            },
            [
              _c("div", { staticClass: "entry_confirm" }, [
                _vm.message && _vm.message.messageConfirm
                  ? _c(
                      "pre",
                      {
                        staticClass:
                          "entry_confirm_text customize_setting_entry_confirm"
                      },
                      [_vm._v(_vm._s(_vm.message.messageConfirm))]
                    )
                  : _vm._e()
              ]),
              _vm.categories.length > 0
                ? _c(
                    "div",
                    _vm._l(_vm.categories, function(category, index) {
                      return _c("div", { key: index }, [
                        category &&
                        !category.categoryDeleted &&
                        !_vm.isEmptyCategory(index)
                          ? _c("div", { staticClass: "mt-2" }, [
                              _c(
                                "h2",
                                {
                                  staticClass: "jobs_category_title",
                                  style: {
                                    color: _vm.colorSetting.pageText,
                                    borderLeftColor: _vm.colorSetting.keyColor
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(category.categoryName) +
                                      "\n              "
                                  ),
                                  category.countCate
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(category.countCate) +
                                            "\n              "
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "jobs_table_wrapper" },
                                _vm._l(category.item, function(
                                  item,
                                  indexItem
                                ) {
                                  return _c(
                                    "table",
                                    {
                                      key: indexItem,
                                      staticClass: "jobs_table"
                                    },
                                    [
                                      _c(
                                        "tbody",
                                        { staticClass: "jobs_table_body" },
                                        [
                                          !_vm.isEmptyItem(item)
                                            ? _c(
                                                "tr",
                                                {
                                                  staticClass: "jobs_table_rows"
                                                },
                                                [
                                                  _c(
                                                    "th",
                                                    {
                                                      staticClass:
                                                        "jobs_table_head",
                                                      style: [
                                                        {
                                                          backgroundColor:
                                                            _vm.colorSetting
                                                              .subColor
                                                        },
                                                        indexItem === 0
                                                          ? {
                                                              border:
                                                                "1px solid" +
                                                                _vm.colorSetting
                                                                  .borderColor
                                                            }
                                                          : {
                                                              borderLeft:
                                                                "1px solid" +
                                                                _vm.colorSetting
                                                                  .borderColor,
                                                              borderRight:
                                                                "1px solid" +
                                                                _vm.colorSetting
                                                                  .borderColor,
                                                              borderBottom:
                                                                "1px solid" +
                                                                _vm.colorSetting
                                                                  .borderColor
                                                            }
                                                      ]
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "jobs_table_head_holder"
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "jobs_table_label",
                                                              style: {
                                                                color:
                                                                  _vm
                                                                    .colorSetting
                                                                    .pageText
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                        " +
                                                                  _vm._s(
                                                                    item.itemName
                                                                  ) +
                                                                  "\n                      "
                                                              )
                                                            ]
                                                          ),
                                                          item.itemRequired
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "entry_required_label",
                                                                  style: {
                                                                    backgroundColor:
                                                                      _vm
                                                                        .colorSetting
                                                                        .requiredLabel,
                                                                    color:
                                                                      _vm
                                                                        .colorSetting
                                                                        .requiredLabelText
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                        " +
                                                                      _vm._s(
                                                                        _vm
                                                                          .labelProperties
                                                                          .LABEL_REQUIRE
                                                                      ) +
                                                                      "\n                      "
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e()
                                                        ]
                                                      ),
                                                      item.resourceField
                                                        .length === 1 &&
                                                      (item.resourceField[0]
                                                        .min_length ||
                                                        item.resourceField[0]
                                                          .max_length)
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "setting_range_allow_input"
                                                            },
                                                            [
                                                              item
                                                                .resourceField[0]
                                                                .type ===
                                                                "textarea" ||
                                                              item
                                                                .resourceField[0]
                                                                .type ===
                                                                "text" ||
                                                              item.resourceField[0].type.includes(
                                                                "email"
                                                              ) ||
                                                              item
                                                                .resourceField[0]
                                                                .type ===
                                                                "tel" ||
                                                              item
                                                                .resourceField[0]
                                                                .type === "url"
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm
                                                                          .labelProperties
                                                                          .WORD_COUNT
                                                                      ) +
                                                                        " " +
                                                                        _vm._s(
                                                                          item
                                                                            .resourceField[0]
                                                                            .min_length
                                                                        ) +
                                                                        " ~ " +
                                                                        _vm._s(
                                                                          item
                                                                            .resourceField[0]
                                                                            .max_length
                                                                        )
                                                                    )
                                                                  ])
                                                                : _vm._e(),
                                                              item
                                                                .resourceField[0]
                                                                .type ===
                                                                "integer" ||
                                                              item
                                                                .resourceField[0]
                                                                .type ===
                                                                "calc" ||
                                                              item
                                                                .resourceField[0]
                                                                .type ===
                                                                "number"
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm
                                                                          .labelProperties
                                                                          .RANGE
                                                                      ) +
                                                                        " " +
                                                                        _vm._s(
                                                                          item
                                                                            .resourceField[0]
                                                                            .min_length
                                                                        ) +
                                                                        " ~ " +
                                                                        _vm._s(
                                                                          item
                                                                            .resourceField[0]
                                                                            .max_length
                                                                        )
                                                                    )
                                                                  ])
                                                                : _vm._e()
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  ),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "jobs_table_cell",
                                                      style: [
                                                        indexItem === 0
                                                          ? {
                                                              border:
                                                                "1px solid" +
                                                                _vm.colorSetting
                                                                  .borderColor
                                                            }
                                                          : {
                                                              borderLeft:
                                                                "1px solid" +
                                                                _vm.colorSetting
                                                                  .borderColor,
                                                              borderRight:
                                                                "1px solid" +
                                                                _vm.colorSetting
                                                                  .borderColor,
                                                              borderBottom:
                                                                "1px solid" +
                                                                _vm.colorSetting
                                                                  .borderColor
                                                            }
                                                      ]
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "jobs_table_form_rows"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "jobs_table_form_item"
                                                            },
                                                            _vm._l(
                                                              _vm.buildListItem(
                                                                item.resourceField
                                                              ),
                                                              function(
                                                                resourceField,
                                                                indexResourceField
                                                              ) {
                                                                return _c(
                                                                  "div",
                                                                  {
                                                                    key: indexResourceField,
                                                                    staticClass:
                                                                      "row"
                                                                  },
                                                                  _vm._l(
                                                                    resourceField.filter(
                                                                      function(
                                                                        resourceSetting
                                                                      ) {
                                                                        return (
                                                                          resourceSetting &&
                                                                          !resourceSetting.isDeletedByMainSystem
                                                                        )
                                                                      }
                                                                    ),
                                                                    function(
                                                                      resource,
                                                                      indexResource
                                                                    ) {
                                                                      return _c(
                                                                        "div",
                                                                        {
                                                                          key: indexResource,
                                                                          staticClass:
                                                                            "col"
                                                                        },
                                                                        [
                                                                          resource.type !==
                                                                          "blank"
                                                                            ? _c(
                                                                                "div",
                                                                                [
                                                                                  (resource.type ===
                                                                                    "single_select" ||
                                                                                    resource.type ===
                                                                                      "select" ||
                                                                                    resource.type ===
                                                                                      "radio") &&
                                                                                  resource.name !==
                                                                                    "sex_id" &&
                                                                                  resource.default_value
                                                                                    ? _c(
                                                                                        "span",
                                                                                        {
                                                                                          domProps: {
                                                                                            textContent: _vm._s(
                                                                                              resource
                                                                                                .default_value
                                                                                                .choiceDisplayName
                                                                                                ? resource
                                                                                                    .default_value
                                                                                                    .choiceDisplayName
                                                                                                : resource
                                                                                                    .default_value
                                                                                                    .choiceName
                                                                                            )
                                                                                          }
                                                                                        }
                                                                                      )
                                                                                    : resource.master_name !==
                                                                                        null &&
                                                                                      (resource.type ===
                                                                                        "boolean" ||
                                                                                        resource.name ===
                                                                                          "sex_id") &&
                                                                                      resource.default_value
                                                                                    ? _c(
                                                                                        "span",
                                                                                        {
                                                                                          domProps: {
                                                                                            textContent: _vm._s(
                                                                                              resource
                                                                                                .default_value
                                                                                                .choiceDisplayName
                                                                                                ? resource
                                                                                                    .default_value
                                                                                                    .choiceDisplayName
                                                                                                : resource
                                                                                                    .default_value
                                                                                                    .choiceName
                                                                                            )
                                                                                          }
                                                                                        }
                                                                                      )
                                                                                    : _vm.TYPE_OF_MULTI_SELECT.includes(
                                                                                        resource.type
                                                                                      )
                                                                                    ? _c(
                                                                                        "span",
                                                                                        [
                                                                                          _vm._v(
                                                                                            "\n                                " +
                                                                                              _vm._s(
                                                                                                _vm.getFormatMultiSelect(
                                                                                                  resource.default_value
                                                                                                )
                                                                                              ) +
                                                                                              "\n                              "
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    : _vm.FORMAT_DATE.includes(
                                                                                        resource.type
                                                                                      ) &&
                                                                                      resource.default_value
                                                                                    ? _c(
                                                                                        "span",
                                                                                        [
                                                                                          _vm._v(
                                                                                            "\n                                " +
                                                                                              _vm._s(
                                                                                                _vm.getDatetimeString(
                                                                                                  resource.type,
                                                                                                  resource.default_value
                                                                                                )
                                                                                              ) +
                                                                                              "\n                              "
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    : resource.name ===
                                                                                        "birth_date" &&
                                                                                      resource.type ===
                                                                                        "date" &&
                                                                                      resource.default_value
                                                                                    ? _c(
                                                                                        "span",
                                                                                        [
                                                                                          _vm._v(
                                                                                            "\n                                " +
                                                                                              _vm._s(
                                                                                                _vm.getFormatBirthDate(
                                                                                                  resource.default_value
                                                                                                )
                                                                                              ) +
                                                                                              "\n                              "
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    : resource.type ===
                                                                                      "textarea"
                                                                                    ? _c(
                                                                                        "pre",
                                                                                        {
                                                                                          staticClass:
                                                                                            "pre-margin-bottom"
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              resource.default_value
                                                                                            )
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    : resource.name ===
                                                                                      "photo"
                                                                                    ? _c(
                                                                                        "div",
                                                                                        [
                                                                                          _c(
                                                                                            "div",
                                                                                            {
                                                                                              staticClass:
                                                                                                "entry_uploader_item_img"
                                                                                            },
                                                                                            [
                                                                                              _vm.photo &&
                                                                                              _vm
                                                                                                .photo
                                                                                                .name
                                                                                                ? _c(
                                                                                                    "div",
                                                                                                    {
                                                                                                      staticClass:
                                                                                                        "entry_uploader_holder"
                                                                                                    },
                                                                                                    [
                                                                                                      !_vm.photo ||
                                                                                                      !_vm
                                                                                                        .photo
                                                                                                        .name
                                                                                                        ? _c(
                                                                                                            "p",
                                                                                                            {
                                                                                                              staticClass:
                                                                                                                "entry_uploader_number",
                                                                                                              style: {
                                                                                                                color:
                                                                                                                  _vm.colorSetting &&
                                                                                                                  _vm
                                                                                                                    .colorSetting
                                                                                                                    .pageText
                                                                                                                    ? _vm
                                                                                                                        .colorSetting
                                                                                                                        .pageText
                                                                                                                    : ""
                                                                                                              }
                                                                                                            },
                                                                                                            [
                                                                                                              _vm._v(
                                                                                                                "\n                                      " +
                                                                                                                  _vm._s(
                                                                                                                    _vm
                                                                                                                      .labelsInputProperties
                                                                                                                      .FILE
                                                                                                                  ) +
                                                                                                                  ":\n                                    "
                                                                                                              )
                                                                                                            ]
                                                                                                          )
                                                                                                        : _vm._e(),
                                                                                                      _vm.photo &&
                                                                                                      _vm
                                                                                                        .photo
                                                                                                        .name
                                                                                                        ? _c(
                                                                                                            "p",
                                                                                                            {
                                                                                                              staticClass:
                                                                                                                "entry_uploader_name ml-2"
                                                                                                            },
                                                                                                            [
                                                                                                              _vm._v(
                                                                                                                "\n                                      " +
                                                                                                                  _vm._s(
                                                                                                                    _vm
                                                                                                                      .photo
                                                                                                                      .name
                                                                                                                  ) +
                                                                                                                  "\n                                    "
                                                                                                              )
                                                                                                            ]
                                                                                                          )
                                                                                                        : _c(
                                                                                                            "p",
                                                                                                            {
                                                                                                              staticClass:
                                                                                                                "entry_uploader_name ml-2 is_disabled"
                                                                                                            },
                                                                                                            [
                                                                                                              _vm._v(
                                                                                                                "\n                                      " +
                                                                                                                  _vm._s(
                                                                                                                    _vm
                                                                                                                      .labelsInputProperties
                                                                                                                      .NOT_SELECTED_FILE
                                                                                                                  ) +
                                                                                                                  "\n                                    "
                                                                                                              )
                                                                                                            ]
                                                                                                          )
                                                                                                    ]
                                                                                                  )
                                                                                                : _vm._e()
                                                                                            ]
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    : resource.name ===
                                                                                      "files"
                                                                                    ? _c(
                                                                                        "div",
                                                                                        _vm._l(
                                                                                          _vm.files,
                                                                                          function(
                                                                                            file,
                                                                                            index
                                                                                          ) {
                                                                                            return _c(
                                                                                              "div",
                                                                                              {
                                                                                                key: index
                                                                                              },
                                                                                              [
                                                                                                file.content &&
                                                                                                file
                                                                                                  .content
                                                                                                  .name
                                                                                                  ? _c(
                                                                                                      "div",
                                                                                                      {
                                                                                                        staticClass:
                                                                                                          "entry_uploader_item"
                                                                                                      },
                                                                                                      [
                                                                                                        _c(
                                                                                                          "div",
                                                                                                          {
                                                                                                            staticClass:
                                                                                                              "entry_uploader_holder"
                                                                                                          },
                                                                                                          [
                                                                                                            !file ||
                                                                                                            !file
                                                                                                              .content
                                                                                                              .name
                                                                                                              ? _c(
                                                                                                                  "p",
                                                                                                                  {
                                                                                                                    staticClass:
                                                                                                                      "entry_uploader_number",
                                                                                                                    style: {
                                                                                                                      color:
                                                                                                                        _vm.colorSetting &&
                                                                                                                        _vm
                                                                                                                          .colorSetting
                                                                                                                          .pageText
                                                                                                                          ? _vm
                                                                                                                              .colorSetting
                                                                                                                              .pageText
                                                                                                                          : ""
                                                                                                                    }
                                                                                                                  },
                                                                                                                  [
                                                                                                                    _vm._v(
                                                                                                                      "\n                                        " +
                                                                                                                        _vm._s(
                                                                                                                          file.name +
                                                                                                                            (index +
                                                                                                                              1)
                                                                                                                        ) +
                                                                                                                        ":\n                                      "
                                                                                                                    )
                                                                                                                  ]
                                                                                                                )
                                                                                                              : _vm._e(),
                                                                                                            _c(
                                                                                                              "p",
                                                                                                              {
                                                                                                                staticClass:
                                                                                                                  "entry_uploader_name ml-2",
                                                                                                                class:
                                                                                                                  index >
                                                                                                                  0
                                                                                                                    ? "mt-3"
                                                                                                                    : ""
                                                                                                              },
                                                                                                              [
                                                                                                                _vm._v(
                                                                                                                  "\n                                        " +
                                                                                                                    _vm._s(
                                                                                                                      file
                                                                                                                        .content
                                                                                                                        .name
                                                                                                                    ) +
                                                                                                                    "\n                                      "
                                                                                                                )
                                                                                                              ]
                                                                                                            )
                                                                                                          ]
                                                                                                        )
                                                                                                      ]
                                                                                                    )
                                                                                                  : _vm._e()
                                                                                              ]
                                                                                            )
                                                                                          }
                                                                                        ),
                                                                                        0
                                                                                      )
                                                                                    : _vm.TYPE_OF_NUMBER.includes(
                                                                                        resource.type
                                                                                      )
                                                                                    ? _c(
                                                                                        "span",
                                                                                        [
                                                                                          _vm._v(
                                                                                            "\n                                " +
                                                                                              _vm._s(
                                                                                                _vm.formatNumberByStep(
                                                                                                  resource.default_value,
                                                                                                  resource.step
                                                                                                )
                                                                                              ) +
                                                                                              "\n                              "
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    : _c(
                                                                                        "span",
                                                                                        {
                                                                                          staticClass:
                                                                                            "break-word"
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            "\n                                " +
                                                                                              _vm._s(
                                                                                                resource.default_value
                                                                                              ) +
                                                                                              "\n                              "
                                                                                          )
                                                                                        ]
                                                                                      ),
                                                                                  resource.unit &&
                                                                                  resource.default_value
                                                                                    ? _c(
                                                                                        "span",
                                                                                        {
                                                                                          staticClass:
                                                                                            "ml-1",
                                                                                          class: {
                                                                                            label_unit_item_long:
                                                                                              resource
                                                                                                .unit
                                                                                                .length >
                                                                                              _vm
                                                                                                .userConfig
                                                                                                .UNIT_LENGTH,
                                                                                            label_unit_item:
                                                                                              resource
                                                                                                .unit
                                                                                                .length <=
                                                                                              _vm
                                                                                                .userConfig
                                                                                                .UNIT_LENGTH
                                                                                          }
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              resource.unit
                                                                                            )
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    : _vm._e()
                                                                                ]
                                                                              )
                                                                            : _vm._e()
                                                                        ]
                                                                      )
                                                                    }
                                                                  ),
                                                                  0
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    ]
                                  )
                                }),
                                0
                              )
                            ])
                          : _vm._e()
                      ])
                    }),
                    0
                  )
                : _vm._e(),
              _vm.policy.isEnabledPolicy && _vm.policy.content !== ""
                ? _c("div", { staticClass: "mt-2" }, [
                    _c(
                      "h2",
                      {
                        staticClass: "jobs_category_title",
                        style: {
                          color: _vm.colorSetting.pageText,
                          borderLeftColor: _vm.colorSetting.keyColor
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.labelProperties.PRIVACY_POLICY_CATEGORY
                            ) +
                            "\n        "
                        )
                      ]
                    ),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.policy.content,
                          expression: "policy.content"
                        }
                      ],
                      staticClass: "jobs_form_textarea",
                      attrs: { readonly: "" },
                      domProps: { value: _vm.policy.content },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.policy, "content", $event.target.value)
                        }
                      }
                    }),
                    _c("div", { staticClass: "entry_policy_checkbox" }, [
                      _c("label", { staticClass: "jobs_form_label" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.agreePrivacyPolicy,
                              expression: "agreePrivacyPolicy"
                            }
                          ],
                          attrs: { type: "checkbox", disabled: "" },
                          domProps: {
                            checked: Array.isArray(_vm.agreePrivacyPolicy)
                              ? _vm._i(_vm.agreePrivacyPolicy, null) > -1
                              : _vm.agreePrivacyPolicy
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.agreePrivacyPolicy,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.agreePrivacyPolicy = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.agreePrivacyPolicy = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.agreePrivacyPolicy = $$c
                              }
                            }
                          }
                        }),
                        _c(
                          "span",
                          {
                            staticClass: "entry_policy_checkbox_text",
                            style: { color: _vm.colorSetting.pageText }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.labelProperties.PRIVACY_POLICY_DEFAULT
                                ) +
                                "\n            "
                            )
                          ]
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm.policy.isEnabledUrl && _vm.policy.textLink !== ""
                ? _c("div", { staticClass: "entry_policy_checkbox" }, [
                    _c("label", { staticClass: "jobs_form_label" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.agreePrivacyPolicyLink,
                            expression: "agreePrivacyPolicyLink"
                          }
                        ],
                        attrs: { type: "checkbox", disabled: "" },
                        domProps: {
                          checked: Array.isArray(_vm.agreePrivacyPolicyLink)
                            ? _vm._i(_vm.agreePrivacyPolicyLink, null) > -1
                            : _vm.agreePrivacyPolicyLink
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.agreePrivacyPolicyLink,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.agreePrivacyPolicyLink = $$a.concat([
                                    $$v
                                  ]))
                              } else {
                                $$i > -1 &&
                                  (_vm.agreePrivacyPolicyLink = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.agreePrivacyPolicyLink = $$c
                            }
                          }
                        }
                      }),
                      _c(
                        "a",
                        {
                          staticClass: "ml-1 mr-3",
                          style: { color: _vm.colorSetting.linkText },
                          attrs: { href: _vm.policy.url, target: "_blank" }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.policy.textLink) +
                              "\n          "
                          )
                        ]
                      )
                    ])
                  ])
                : _vm._e(),
              _c("div", { staticClass: "jobs_btn_box" }, [
                _c(
                  "button",
                  {
                    staticClass: "jobs_btn_secondary",
                    style: {
                      color: _vm.colorSetting.subButtonText,
                      backgroundColor: _vm.colorSetting.subButton,
                      border: "1px solid" + _vm.colorSetting.borderColor
                    },
                    on: {
                      click: function($event) {
                        return _vm.backStep(1)
                      }
                    }
                  },
                  [
                    !_vm.button.returnButton
                      ? _c("span", [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.labelProperties.BACK_BUTTON) +
                              "\n          "
                          )
                        ])
                      : _c("span", [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.button.returnButton) +
                              "\n          "
                          )
                        ])
                  ]
                ),
                _c(
                  "button",
                  {
                    staticClass: "jobs_btn_primary",
                    style: {
                      color: _vm.colorSetting.mainButtonText,
                      backgroundColor: _vm.colorSetting.mainButton,
                      border: "1px solid" + _vm.colorSetting.borderColor
                    },
                    on: {
                      "~click": function($event) {
                        return _vm.nextStep(3)
                      }
                    }
                  },
                  [
                    !_vm.button.entryButton
                      ? _c("span", [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.labelProperties.ENTRY_BUTTON) +
                              "\n          "
                          )
                        ])
                      : _c("span", [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.button.entryButton) +
                              "\n          "
                          )
                        ])
                  ]
                )
              ])
            ]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.step === 3,
                  expression: "step === 3"
                }
              ]
            },
            [
              _c("div", { staticClass: "entry_complete" }, [
                _c("p", { staticClass: "entry_complete_title" }, [
                  _vm.message && _vm.message.messageTitleCompletion
                    ? _c("span", [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.message.messageTitleCompletion) +
                            "\n          "
                        )
                      ])
                    : _c("span", [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.labelProperties
                                .MESSAGE_TITLE_COMPLETION_DEFAULT
                            ) +
                            "\n          "
                        )
                      ])
                ]),
                _vm.message && _vm.message.messageBodyCompletion
                  ? _c(
                      "pre",
                      {
                        staticClass:
                          "entry_complete_text customize_setting_entry_confirm mt-5"
                      },
                      [_vm._v(_vm._s(_vm.message.messageBodyCompletion))]
                    )
                  : _c("p", { staticClass: "entry_complete_text mt-5" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.labelProperties.MESSAGE_CONTENT_1) +
                          "\n          "
                      ),
                      _c("br"),
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.labelProperties.MESSAGE_CONTENT_2) +
                          "\n        "
                      )
                    ]),
                _c("div", { staticClass: "jobs_btn_box mt-5" }, [
                  _vm.jobDetailId > 0
                    ? _c(
                        "button",
                        {
                          staticClass: "jobs_btn_secondary",
                          style: {
                            color: _vm.colorSetting.subButtonText,
                            backgroundColor: _vm.colorSetting.subButton,
                            border: "1px solid" + _vm.colorSetting.borderColor
                          },
                          on: {
                            click: function($event) {
                              return _vm.backToJobDetail(_vm.jobDetailId)
                            }
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.labelProperties.BUTTON_BACK_TO_JOB_DETAIL
                                ) +
                                "\n            "
                            )
                          ])
                        ]
                      )
                    : _vm._e()
                ])
              ])
            ]
          )
        ])
      : _vm._e(),
    _c("div", { ref: "ref_botton_top", staticClass: "setting_botton_top" }, [
      _c(
        "button",
        {
          staticClass: "setting_btn_primary",
          style: {
            color: _vm.colorSetting.mainButtonText,
            backgroundColor: _vm.colorSetting.mainButton,
            border: "1px solid" + _vm.colorSetting.borderColor
          },
          on: { click: _vm.onTopPage }
        },
        [
          _c(
            "svg",
            {
              attrs: {
                stroke: "currentColor",
                fill: "currentColor",
                "stroke-width": "0",
                viewBox: "0 0 320 512",
                height: "1em",
                width: "1em"
              }
            },
            [
              _c("path", {
                attrs: {
                  d:
                    "M177 159.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 255.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 329.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1z"
                }
              })
            ]
          )
        ]
      )
    ]),
    _vm.isDisplayPrint
      ? _c("div", { staticClass: "setting_btn_print" }, [
          _c(
            "button",
            {
              staticClass: "setting_btn_primary",
              style: {
                color: _vm.colorSetting.mainButtonText,
                backgroundColor: _vm.colorSetting.mainButton,
                border: "1px solid" + _vm.colorSetting.borderColor
              },
              on: {
                click: function($event) {
                  return _vm.printPage()
                }
              }
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "1rem",
                    height: "1rem",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "#ffffff",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }
                },
                [
                  _c("polyline", { attrs: { points: "6 9 6 2 18 2 18 9" } }),
                  _c("path", {
                    attrs: {
                      d:
                        "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"
                    }
                  }),
                  _c("rect", {
                    attrs: { x: "6", y: "14", width: "12", height: "8" }
                  })
                ]
              )
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }